// Pasted candidate text (an email about the candidate, recruiter notes)
// becomes a resume without a file — the backend stores it as a text source
// and extracts whatever it can for review.

import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardBody } from "@/components/ui/card";
import { Textarea } from "@/components/ui/input";

export function PasteStage({
  onConfirm,
  onCancel,
  busy,
}: {
  onConfirm: (text: string) => void;
  onCancel: () => void;
  busy: boolean;
}) {
  const [text, setText] = useState("");

  return (
    <Card>
      <CardBody className="flex flex-col gap-3">
        <div>
          <p className="font-semibold text-text">Paste candidate information</p>
          <p className="text-[13px] text-text-2">
            It doesn&rsquo;t need to be a full resume — an email or rough notes work too. The AI
            structures what it finds and flags everything else for your review.
          </p>
        </div>
        <Textarea
          rows={10}
          value={text}
          autoFocus
          placeholder={"Reiko Hirata\n\nGraduated from University\nDaiwa\nUSB\nDB\nBofA\n2011 - Hawaii 7 years break\n\n2017 UBS…"}
          onChange={(e) => setText(e.target.value)}
          disabled={busy}
        />
        <div className="flex items-center gap-2">
          <Button onClick={() => onConfirm(text)} disabled={busy || !text.trim()}>
            <Sparkles size={15} strokeWidth={1.75} aria-hidden />
            {busy ? "Starting…" : "Extract resume"}
          </Button>
          <Button variant="secondary" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}
